import { useQuery } from '@tanstack/react-query';
import { getCurrencies, getLocations } from 'lib/supabaseQueries';
import { useAuthContext } from 'context/authContext';

// Hook to fetch all currencies
export function useCurrencies() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['currencies'],
    queryFn: getCurrencies,
    staleTime: 30 * 60 * 1000 // Cache for 30 minutes (currencies don't change often)
  });

  return {
    currencies: data?.data || [],
    isLoading,
    error: error || data?.error,
    refetch
  };
}

// Hook to fetch locations for organization
export function useLocations() {
  const { organization, isInitialized } = useAuthContext();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['locations', organization?.id],
    queryFn: () => getLocations(organization.id),
    enabled: isInitialized && !!organization?.id,
    staleTime: 10 * 60 * 1000 // Cache for 10 minutes
  });

  return {
    locations: data?.data || [],
    isLoading,
    error: error || data?.error,
    refetch
  };
}
